import { gql } from '@apollo/client';
import PRODUCT from 'api/fragments/PRODUCT';
const GET_PRODUCT = gql `
  ${PRODUCT}
  query GetProduct($productId: ID!) {
    node(id: $productId) {
      ... on ProductNode {
        ...ProductFragment
      }
    }
  }
`;
export default GET_PRODUCT;
